/**
 * Módulo para generar JSONs de Comprobantes Fiscales Electrónicos (e-CF) según su tipo
 * Este script procesa los datos del sistema y genera JSONs específicos para cada tipo de comprobante
 * basados en los esquemas XSD correspondientes (31, 32, 33, 34, 41, 43, 44, 45, 46, 47)
 */

import processECFByType from './processECFByType';

/**
 * Genera un JSON de Comprobante Fiscal Electrónico según el tipo identificado en los datos
 * @param {Object} systemData - Datos del sistema en formato JSON
 * @returns {Object} - JSON del comprobante fiscal electrónico según su tipo
 */
function generateECFJson(systemData) {
  try {
    // Procesar los datos del sistema y generar el JSON según el tipo de comprobante
    const ecfData = processECFByType(systemData);
    return ecfData;
  } catch (error) {
    console.error('Error al generar el JSON del e-CF:', error);
    return null;
  }
}

/**
 * Genera JSONs para todos los tipos de comprobantes fiscales electrónicos
 * utilizando los datos del sistema como base
 * @param {Object} systemData - Datos del sistema en formato JSON
 * @returns {Object} - Objeto con todos los JSONs generados para cada tipo de comprobante
 */
function generateAllECFJsons(systemData) {
  try {
    const allEcfJsons = {};
    
    // Tipos de comprobantes fiscales electrónicos
    const tiposECF = ['31', '32', '33', '34', '41', '43', '44', '45', '46', '47'];
    
    // Generar JSON para cada tipo de comprobante
    tiposECF.forEach(tipo => {
      // Clonar los datos del sistema para no modificar el original
      const clonedData = JSON.parse(JSON.stringify(systemData));
      
      // Modificar el tipo de comprobante en los datos clonados
      if (clonedData.invoice_ncf && clonedData.invoice_ncf.length >= 3) {
        clonedData.invoice_ncf = `E${tipo}${clonedData.invoice_ncf.substring(3)}`;
      } else {
        clonedData.invoice_ncf = `E${tipo}0000000001`;
      }
      
      // Procesar los datos y generar el JSON para este tipo
      const ecfData = processECFByType(clonedData);
      
      // Almacenar el JSON generado
      allEcfJsons[tipo] = ecfData;
    });
    
    return allEcfJsons;
  } catch (error) {
    console.error('Error al generar todos los JSONs de e-CF:', error);
    return null;
  }
}

// Exportar las funciones para su uso en otros archivos
export { generateECFJson, generateAllECFJsons };